import Frame from "./Frame"
import SideMenu from "../components/SideMenu"
import { Outlet } from "react-router-dom"

export default function F0(){
    return(
      <>
        <Frame>
          <SideMenu />
          <Outlet />
        </Frame>
      </>  
    )
  }
  